import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';

export type TransportOrderDetailFooterProps = {
    onEdit: () => void;
    onCancelOrder: () => void;
};

const TransportOrderDetailFooter = ({ onEdit, onCancelOrder }: TransportOrderDetailFooterProps) => (
    <ButtonToolbar alignment='right'>
        <Button onClick={onCancelOrder}>Cancel order</Button>
        <Button bsStyle={Button.PRIMARY} iconName='pencil' onClick={onEdit}>
            Edit
        </Button>
    </ButtonToolbar>
);

export default TransportOrderDetailFooter;
